export const isBrowser = typeof window !== 'undefined';

export const getPixelRatio = () => (isBrowser && window.devicePixelRatio) || 1;

// tslint:disable-next-line:ban-types
export function isFunction(functionToCheck: any): functionToCheck is Function {
  return (
    functionToCheck && {}.toString.call(functionToCheck) === '[object Function]'
  );
}
